import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
var _Math;
import { logError } from "@faire/web--source/common/logging";
import { MoneyMath } from "@faire/web--source/common/MoneyMath";
import { ObservableMap, ObservableSet } from "mobx";
export var isProductCustomizationActive = function(customization) {
    return !!customization.active;
};
export var hasActiveProductCustomizations = function(customizations) {
    return customizations.some(isProductCustomizationActive);
};
export var isProductCustomizationRequired = function(customization) {
    return !!customization.required;
};
var getProductCustomizationsAdditionalCharge = function(customizations) {
    var _MoneyMath;
    var additionalCharges = customizations.filter(isProductCustomizationActive).map(function(customization) {
        var _customization_additional_promo_charge;
        var _customization_additional_promo_charge_discounted_item_price;
        return (_customization_additional_promo_charge_discounted_item_price = (_customization_additional_promo_charge = customization.additional_promo_charge) === null || _customization_additional_promo_charge === void 0 ? void 0 : _customization_additional_promo_charge.discounted_item_price) !== null && _customization_additional_promo_charge_discounted_item_price !== void 0 ? _customization_additional_promo_charge_discounted_item_price : customization.additional_charge;
    });
    if (additionalCharges.length === 0) {
        return undefined;
    }
    return (_MoneyMath = MoneyMath).sum.apply(_MoneyMath, _to_consumable_array(additionalCharges));
};
export var getAppliedProductCustomizationsAdditionalCharge = function(customizations, appliedCustomizations) {
    return getProductCustomizationsAdditionalCharge(customizations.filter(function(c) {
        return isProductCustomizationApplied(c, appliedCustomizations) || c.required;
    }));
};
export var getRequiredProductCustomizationsAdditionalCharge = function(customizations) {
    return getProductCustomizationsAdditionalCharge(customizations.filter(isProductCustomizationRequired));
};
export var getProductCustomizationMinimumOrderQuantity = function(customization) {
    return typeof customization.min_order_quantity === "number" ? customization.min_order_quantity : -Infinity;
};
export var getProductCustomizationsMinimumOrderQuantity = function(customizations) {
    return (_Math = Math).max.apply(_Math, _to_consumable_array(customizations.filter(isProductCustomizationActive).map(getProductCustomizationMinimumOrderQuantity)));
};
export var isProductCustomizationAppliedFromItemCustomizations = function(customization, itemCustomizations) {
    if (!isProductCustomizationActive(customization)) {
        return false;
    }
    return itemCustomizations.some(function(itemCustomization) {
        return itemCustomization.product_customization_token === customization.token;
    });
};
export var isProductCustomizationAppliedFromMap = function(customization, appliedCustomizations) {
    if (!isProductCustomizationActive(customization)) {
        return false;
    }
    if (!customization.token) {
        return false;
    }
    var applied = appliedCustomizations.get(customization.token);
    return applied !== undefined && applied.trim().length > 0;
};
export var isProductCustomizationAppliedFromSet = function(customization, appliedCustomizations) {
    return isProductCustomizationActive(customization) && !!customization.token && appliedCustomizations.has(customization.token);
};
var isProductCustomizationApplied = function(customization, appliedCustomizations) {
    if (Array.isArray(appliedCustomizations)) {
        return isProductCustomizationAppliedFromItemCustomizations(customization, appliedCustomizations);
    } else if (appliedCustomizations instanceof Map || appliedCustomizations instanceof ObservableMap) {
        return isProductCustomizationAppliedFromMap(customization, appliedCustomizations);
    } else if (appliedCustomizations instanceof ObservableSet || appliedCustomizations instanceof Set) {
        return isProductCustomizationAppliedFromSet(customization, appliedCustomizations);
    }
    logError(new Error("Unexpected value ".concat(appliedCustomizations, " for appliedCustomizations in isProductCustomizationApplied")));
    return false;
};
export var getAppliedProductCustomizations = function(customizations, appliedCustomizations) {
    return customizations.filter(function(c) {
        return isProductCustomizationApplied(c, appliedCustomizations);
    });
};
export var areProductCustomizationsApplied = function(customizations, appliedCustomizations) {
    return customizations.every(function(c) {
        return isProductCustomizationApplied(c, appliedCustomizations);
    });
};
export var areRequiredProductCustomizationsApplied = function(customizations, appliedCustomizations) {
    return areProductCustomizationsApplied(customizations.filter(isProductCustomizationRequired), appliedCustomizations);
};
// Verifies that applied customizations for all active customizations exist and are not empty.
export var areAppliedProductCustomizationsValid = function(activeCustomizations, appliedCustomizations) {
    return _to_consumable_array(activeCustomizations).every(function(activeCustomization) {
        var applied = appliedCustomizations.get(activeCustomization);
        return applied !== undefined && applied.trim().length > 0;
    });
};
